import { useTranslation } from "react-i18next";
import { formatCampaignNotificationDateTime } from "../utils/campaignNotificationHistoryUtils";
import { formatCampaignTitleCase } from "../campaignFormatUtils";
import { formatMaterialNameForDisplay } from "../../../shared/utils/materialNameNormalizer";

const CampaignNotificationHistoryRow = ({ row }) => {
  const { t } = useTranslation();

  return (
    <div className="table-standard-row campaign-notification-history-row">
      <div className="table-standard-row-cell">
        <div className="campaign-notification-history-row__stack">
          <span className="campaign-notification-history-row__primary">
            {formatCampaignNotificationDateTime(row.date)}
          </span>
          {row.treatmentDurationDisplay ? (
            <span className="campaign-notification-history-row__secondary">
              {row.treatmentDurationDisplay}
            </span>
          ) : null}
        </div>
      </div>
      <div className="table-standard-row-cell">
        <div className="campaign-notification-history-row__stack">
          <span className="campaign-notification-history-row__primary">
            {row.positioning ? formatCampaignTitleCase(row.positioning) : "-"}
          </span>
          {row.wasteName ? (
            <span className="campaign-notification-history-row__secondary">
              {formatCampaignTitleCase(row.wasteName)}
            </span>
          ) : null}
        </div>
      </div>
      <div className="table-standard-row-cell">
        {row.errorType ? formatMaterialNameForDisplay(row.errorType, t) : "-"}
      </div>
      <div className="table-standard-row-cell">{row.errorCount ?? 0}</div>
      <div className="table-standard-row-cell">
        <div className="campaign-notification-history-row__stack">
          <span className="campaign-notification-history-row__primary">
            {row.removalDisplay?.main || "-"}
          </span>
          {row.removalDisplay?.sub ? (
            <span className="campaign-notification-history-row__secondary">
              {row.removalDisplay.sub}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CampaignNotificationHistoryRow;
